import axios from 'axios';
import { decodeToken } from '../../components/utils/decodeToken/decodeToken';

const apiUrl = process.env.REACT_APP_API_URL;

export const sensorsList = async () => {
    try {
        const token = decodeToken(localStorage.getItem('user-jwt'))
        const response = await axios.get(`${apiUrl}/sensors/sensors-from`, {
            params: {
                idUser: token.sub,
            },
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error al obtener información de los sensores: ', error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};

export const getCurrentReadings = async () => {
    try {
        const token = decodeToken(localStorage.getItem('user-jwt'))
        const response = await axios.get(`${apiUrl}/sensors/current-readings`, {
            params: {
                idUser: token.sub,
            },
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error al obtener las últimas lecturas de los sensores: ', error);
        throw error;
    }
};

export const sensorGraphs = async (sensorData) => {
    try {
        const response = await axios.post(`${apiUrl}/sensors/update-sensor`, sensorData, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response;
    } catch (error) {
        console.error('Error al obtener información del sensor: ', error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};

// Variables del sensor para abrir sus gráficas sin modificarlo (quien solo puede verlo)
export const getSensorVariables = async (sensorId) => {
    const response = await axios.get(`${apiUrl}/sensors/${sensorId}/variables`, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
        },
    });
    return response.data;
};

export const sensorUpdateData = async (sensorData) => {
    try {
        const response = await axios.post(`${apiUrl}/sensors/update-sensor`, sensorData, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response;
    } catch (error) {
        console.error('Error al actualizar la información del sensor: ', error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};

export const getSensors = async (page, limit, filters = {}) => {
    try {
        const response = await axios.get(`${apiUrl}/sensors/all`, {
            params: {
                page,
                limit,
                ...filters
            },
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error al obtener la información de los sensores', error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}

export const getSensor = async (sensorId) => {
    try {
        const response = await axios.get(`${apiUrl}/sensors/${sensorId}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error(`Error al obtener la sensor id ${sensorId}: `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};

export const addSensor = async (body) => {
    try {
        const response = await axios.post(`${apiUrl}/sensors/create`, body, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error al crear la sim: ", error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}

export const editSensor = async (sensorId, body) => {
    try {
        const response = await axios.put(`${apiUrl}/sensors/${sensorId}`, body, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error(`Error al actualizar la sim id ${sensorId}: `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}


export const deleteSensor = async (sensorId) => {
    try {
        const response = await axios.delete(`${apiUrl}/sensors/${sensorId}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response;
    } catch (error) {
        console.error(`Error al eliminar el sensor id ${sensorId}: `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}